var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7096 1.53354C14.4506 1.70022 14.9161 2.43598 14.7493 3.17722C14.6724 3.51871 14.5672 3.80289 14.4136 4.04009C12.253 7.37623 12.6005 9.57691 14.0419 9.79011C15.4511 9.99855 16.2388 9.09756 16.0118 6.99998C15.9585 6.50756 15.9139 6.09245 15.8781 5.75456C15.8452 5.44458 15.921 5.1328 16.0925 4.87252C16.5013 4.25232 17.3354 4.08091 17.9556 4.48963C18.7009 4.98079 19.5358 5.81691 20.4897 7.0066C23.1991 10.3859 24.0365 13.3403 23.9986 16.3656C23.928 22.002 19.7257 26 13.9993 26C8.2488 26 4 21.9781 4 16.3472C4.02924 11.3675 6.74056 5.95714 11.8113 2.33884C12.0076 2.1987 12.2671 2.00906 12.5888 1.77055C12.9101 1.53226 13.3193 1.44573 13.7096 1.53354ZM11.6308 5.02192C7.96012 8.19685 6.02285 12.4611 5.99998 16.3531C5.99998 20.8482 9.32957 24 13.9993 24C18.6472 24 21.9421 20.8652 21.9988 16.3406C22.0313 13.7467 21.321 11.2406 18.9293 8.25768C18.6113 7.86107 18.3127 7.51365 18.0351 7.21588C18.198 10.284 16.4217 12.1639 13.7493 11.7686C11.0427 11.3682 10.167 8.51666 11.6308 5.02192Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireOutline);
export default __webpack_public_path__ + "static/media/fire_outline.36bda12ce322a5beadeeefae10d03eef.svg";
export { ForwardRef as ReactComponent };